const AI_VISIBILITY_QUERY_KEY_ROOT = 'ai-visibility'

export const AI_VISIBILITY_API_PATHS = {
  DATASET: '/api/ai-visibility/dataset',
  RUNS: '/api/ai-visibility/runs',
} as const

export const DATASET_SELECTION_MODE = {
  RUN: 'run',
  RANGE: 'range',
} as const

export type DatasetSelectionMode =
  (typeof DATASET_SELECTION_MODE)[keyof typeof DATASET_SELECTION_MODE]

export type DatasetSelection =
  | { mode: typeof DATASET_SELECTION_MODE.RUN; runId: string }
  | { mode: typeof DATASET_SELECTION_MODE.RANGE; from: string; to: string }

export function datasetSelectionKey(selection: DatasetSelection): string {
  if (selection.mode === DATASET_SELECTION_MODE.RANGE) {
    return `${DATASET_SELECTION_MODE.RANGE}:${selection.from}:${selection.to}`
  }
  return selection.runId
}

export function datasetSelectionParams(selection: DatasetSelection): Record<string, string> {
  if (selection.mode === DATASET_SELECTION_MODE.RANGE) {
    return { from: selection.from, to: selection.to }
  }
  return { runId: selection.runId }
}

export const AI_VISIBILITY_QUERY_KEYS = {
  runs: (organizationId: string | null) =>
    [AI_VISIBILITY_QUERY_KEY_ROOT, 'runs', organizationId] as const,
  dataset: (organizationId: string | null, selectionKey: string | null) =>
    [AI_VISIBILITY_QUERY_KEY_ROOT, 'dataset', organizationId, selectionKey] as const,
}
